exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-title p[data-v-72be0817] {\n  margin: 0;\n}\n", ""]);

